import BudgetLinesTable from './table/BudgetLinesTable';
import { ElementTypeDto } from 'api/elements/Models/ElementTypeDto';
import { SupplierDto } from 'api/suppliers/models/SupplierDto';
import { TaxDto } from 'api/taxes/models/TaxDto';
import { UnitDto } from 'api/units/models/UnitDto';
import { LinesDataProvider } from './LinesDataProvider';
import { BudgetsCacheData } from '../utils/BudgetsCache';

interface Props {
    type: 'create' | 'details' | 'edit' | 'version' | undefined;
    units: UnitDto[];
    taxes: TaxDto[];
    suppliers: SupplierDto[];
    elementTypes: ElementTypeDto[];
    budgetData: BudgetsCacheData;
}

function BudgetLines({ type, units, taxes, suppliers, elementTypes, budgetData }: Props): JSX.Element | null {
    const isDetails = type === 'details' || type === 'version';

    return (
        <LinesDataProvider.Provider value={{ taxes, units, suppliers, elementTypes, hiddenColumns: budgetData.hiddenColumns, columnsOrder: budgetData.columnsOrder ?? [] }}>
            <BudgetLinesTable
                disabled={isDetails}
            />
        </LinesDataProvider.Provider>
    );
}

export default BudgetLines;
